import { gapi } from "gapi-script";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { PACKAGE_NAME } from "../constants/index";
import { requestNativeSSO } from "../../../../src/services/utils/nativeEvents/sso";
import { isWebView } from "../../../../src/services/utils/nativeBridge";

export const useSignin = ({ tryGoogleAuthorisedUserLogin }) => {
  const selectedRoleId = useRef(null);
  const [loading, setLoading] = useState(false);

  async function handleSSOSuccess(res) {
    const payload = {
      google_token: `${res.access_token}`,
      roleId: !!selectedRoleId.current ? +selectedRoleId.current : -1,
      package: PACKAGE_NAME,
    };

    const response = await tryGoogleAuthorisedUserLogin(
      payload.google_token,
      payload.roleId,
      payload.package
    );
    if (response) {
      window.location.href = "/dashboard/pm-dashboard";
    } else {
      toast.error("Something went wrong!");
    }
  }

  const requestSSOfromNative = async () => {
    const { response, error } = await requestNativeSSO();
    if (response) {
      handleSSOSuccess({ access_token: response });
    } else if (error) {
      toast.error(error);
    }
  };

  const requestSSO = async (payload) => {
    if (!payload.role_id) return;
    selectedRoleId.current = payload.role_id;

    setTimeout(() => {
      setLoading(true);
      if (isWebView()) {
        requestSSOfromNative();
      } else {
        if (gapi) {
          gapi.load("auth2", function () {
            const auth2 = gapi.auth2.init({
              client_id: process.env.REACT_APP_GOOGLE_SSO_CLIENT_API,
              plugin_name: "chat",
            });
            auth2
              .signIn()
              .then(function (googleUser) {
                // Retrieve the ID token from the signed-in user
                const idToken = googleUser.getAuthResponse().id_token;
                handleSSOSuccess({ access_token: idToken });
              })
              .catch(function (error) {
                console.error("Sign-in error:", error);
              });
          });
        }
      }
      setLoading(false);
    }, 0);
  };

  return { requestSSO, loading };
};
